import Layout from '@layout/Index'

export const intelligentOutboundCall = [
  {
    path: '/intelligent-outbound-call',
    component: Layout,
    children: [
      {
        path: '',
        redirect: 'table',
      },
      {
        path: 'table',
        component: () => import(/* webpackChunkName: "intelligent-outbound-call-table" */ './pages/IntelligentOutboundCallTable.vue'),
        meta: {
          title: '智能外呼列表',
        },
      },
      {
        path: 'detail-table/:call_task_id',
        component: () => import(/* webpackChunkName: "intelligent-outbound-call-table" */ './pages/IntelligentOutboundCallDetailTable.vue'),
        meta: {
          title: '外呼明细',
        },
      },
      {
        path: 'record-table/:id',
        component: () => import(/* webpackChunkName: "intelligent-outbound-call-table" */ './pages/IntelligentOutboundCallRecordTable.vue'),
        meta: {
          title: '外呼记录',
        },
      },
      {
        path: 'upload',
        component: () => import(/* webpackChunkName: "intelligent-outbound-call-table" */ './pages/IntelligentOutboundCallUploadTable.vue'),
        meta: {
          title: '批量任务',
        },
      },
      {
        path: 'create',
        component: () => import(/* webpackChunkName: "intelligent-outbound-call-form" */ './pages/IntelligentOutboundCallForm.vue'),
        meta: {
          title: '添加智能外呼',
        },
      },
      {
        path: 'update/:id',
        component: () => import(/* webpackChunkName: "intelligent-outbound-call-form" */ './pages/IntelligentOutboundCallForm.vue'),
        meta: {
          title: '修改智能外呼',
        },
      },
      {
        path: 'detail/:id',
        component: () => import(/* webpackChunkName: "intelligent-outbound-call-detail" */ './pages/IntelligentOutboundCallDetail.vue'),
        meta: {
          title: '智能外呼详情',
        },
      },
    ],
  },
]



// WEBPACK FOOTER //
// ./src/views/intelligent-outbound-call/intelligent-outbound-call.route.js